import { render, staticRenderFns } from "./dashboardOverview.vue?vue&type=template&id=0139657e&scoped=true"
import script from "./dashboardOverview.vue?vue&type=script&lang=js"
export * from "./dashboardOverview.vue?vue&type=script&lang=js"
import style0 from "./dashboardOverview.vue?vue&type=style&index=0&id=0139657e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0139657e",
  null
  
)

export default component.exports